(function () {
  var numbersSlide = () => {
    var $slickElement = $('.section-numbers__slider').not('.slick-initialized');
    var numberOnTheDesktop = $('.section-numbers__slider .section-numbers__slide').length;
    if (numberOnTheDesktop > 4) {
      numberOnTheDesktop = 4;
    }

    $slickElement.slick({
      slidesToShow: numberOnTheDesktop,
      arrows: false,
      dots: true,
      adaptiveHeight: true,
      responsive: [
        {
          breakpoint: 1330,
          settings: {
            slidesToShow: 2,
          }
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
          }
        }
      ]
    });

    const slickSlider = document.querySelector('.section-numbers__slider');

    if (slickSlider) {
      slickSlider.addEventListener('mouseover', (event) => {
        const target = event.target.closest('.section-numbers__slide');

        if (target) {
          const currentHovered = slickSlider.querySelector('.section-numbers__slide.hover');

          if (currentHovered && currentHovered !== target) {
            currentHovered.classList.remove('hover');
          }

          target.classList.add('hover');
        }
      });
    }

  }

  document.addEventListener('shopify:section:load', function () {
    numbersSlide();
  });

  numbersSlide();

})();